module.exports = __webpack_public_path__ + "img/step5.ff56f9c8.png";